import React from 'react';
import { TextArea as TextAreaUIKit, TextInput as TextInputUIKit, } from '@gravity-ui/uikit';
import { useEffectOnce } from 'react-use';
// TODO: remove after fix https://github.com/yandex-cloud/uikit/issues/133
export const TextInputFixed = React.forwardRef((props, ref) => {
    var _a;
    const inputRef = React.useRef(null);
    const controlRef = (_a = props.controlRef) !== null && _a !== void 0 ? _a : inputRef;
    useEffectOnce(() => {
        if (props.autoFocus) {
            setTimeout(() => {
                var _a;
                (_a = controlRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 30);
        }
    });
    return React.createElement(TextInputUIKit, Object.assign({ ref: ref }, props, { controlRef: controlRef, autoFocus: false }));
});
TextInputFixed.displayName = 'TextInputFixed';
// TODO: remove after fix https://github.com/yandex-cloud/uikit/issues/133
export const TextAreaFixed = React.forwardRef((props, ref) => {
    var _a;
    const inputRef = React.useRef(null);
    const controlRef = (_a = props.controlRef) !== null && _a !== void 0 ? _a : inputRef;
    useEffectOnce(() => {
        if (props.autoFocus) {
            setTimeout(() => {
                var _a;
                (_a = controlRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 30);
        }
    });
    return React.createElement(TextAreaUIKit, Object.assign({ ref: ref }, props, { controlRef: controlRef, autoFocus: false }));
});
TextAreaFixed.displayName = 'TextInputFixed';
